module.exports = __webpack_public_path__ + "img/Minstrel show 1964 bugle 1.390c0c3c.jpg";